import { format } from "date-fns";
import i18n from "i18n-js";
import { DELETE, GET, POST, PUT } from "../utils/crud";

export const createObservation = async (body) => await POST("observations", body)
export const updateObservation = async (body, id) => await PUT(`observations/${id}`, body)
export const getObservationList = async (payload) => {
  const params = new URLSearchParams();

  // 👇 solo agregamos si existen
  if (payload?.patient?.id) {
    params.append("patient_id", String(payload.patient.id));
  }

  if (payload?.staff?.id) {
    params.append("created_by", String(payload.staff.id));
  }

  if (payload?.start) {
    params.append("created_at_from", format(new Date(payload.start), i18n.t('general.dateFormatFirstYear')));
  }

  if (payload?.end) {
    params.append("created_at_to", format(new Date(payload.end), i18n.t('general.dateFormatFirstYear')));
  }

  const queryString = params.toString();
  const url = queryString ? `observations?${queryString}` : "observations";
  const response = await GET(url)
  return response;
};
export const getObservationTypes = async () => await GET("observation-types")
export const deleteObservationList = async (id) => await DELETE(`observations/${id}`)